<template>
  <view class="pft-data-compare-1-container-component" flex="dir:top main:justify cross:stretch">
    <Loading v-if="componentLoading" />
    <template v-else>
      <view flex="dir:left main:justify cross:center">
        <view class="pft-data-compare-1-item" flex="dir:left main:center cross:center">
          <text class="text-title">{{ data[0].name }}</text>
          <view class="text-data" :style="{ color: color[0] }">
            <template v-if="percent">{{ progressData.data1 }}</template>
            <template v-else>{{ numeral(data[0].value).format("0,0") }}</template>
          </view>
        </view>
        <view class="pft-data-compare-1-item" flex="dir:left main:center cross:center">
          <text class="text-title">{{ data[1].name }}</text>
          <view class="text-data" :style="{ color: color[1] }">
            <template v-if="percent">{{ progressData.data2 }}</template>
            <template v-else>{{ numeral(data[1].value).format("0,0") }}</template>
          </view>
        </view>
      </view>
      <view flex="dir:left main:justify cross:center" class="progress-bar-containrt">
        <view
          class="progress-bar"
          :style="{
            width: progressData.data1,
            background: background[0],
          }"
        >
        </view>
        <view
          class="progress-bar"
          :style="{
            width: progressData.data2,
            background: background[1],
          }"
        >
        </view>
      </view>
    </template>
  </view>
</template>
<script lang="ts" setup>
import { ref, computed } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import numeral from "numeral"

interface compareData {
  name: string
  value: number
}

interface DataCompareProps {
  data: [compareData, compareData]
  color?: [string, string]
  background?: [string, string]
  percent?: boolean
}

const props = withDefaults(defineProps<DataCompareProps>(), {
  data: () => [
    { name: "", value: 0 },
    { name: "", value: 0 },
  ],
  color: () => ["#4cb7ff", "#fcf072"],
  background: () => ["#4cb7ff", "#fcf072"],
  percent: () => false,
})

const componentLoading = ref<boolean>(true)

const data = ref<[compareData, compareData]>(props.data)

const progressData = computed(() => {
  const [data1, data2] = data.value
  const total = data1.value + data2.value
  return {
    data1: total === 0 ? "50%" : `${((data1.value / total) * 100).toFixed(2)}%`,
    data2: total === 0 ? "50%" : `${((data2.value / total) * 100).toFixed(2)}%`,
  }
})

const loading = () => {
  componentLoading.value = true
}

const setData = (val: [compareData, compareData]) => {
  componentLoading.value = false
  data.value = val
}

defineExpose({ loading, setData })
</script>
<style lang="scss">
.pft-data-compare-1-container-component {
  position: relative;
  box-sizing: border-box;
  padding: 8px 22px 8px 16px;
  width: 100%;
  .text-title {
    font-family:
      Segoe UI,
      Segoe UI;
    font-weight: 400;
    font-size: 16px;
    color: rgba(230, 247, 255, 0.75);
    line-height: 24px;
    text-align: left;
  }
  .text-data {
    margin-left: 4px;
    font-family:
      Segoe UI,
      Segoe UI;
    font-weight: 400;
    font-size: 16px;
    color: #2b9ff7;
    text-align: left;
    line-height: 24px;
  }
  .progress-bar-containrt {
    width: 100%;
    height: 8px;
    margin: 8px 0;
    .progress-bar {
      height: 100%;
    }
  }
}
</style>
